import { ConnectionAction } from '../hook/useUserConnection';
import { createContext, Dispatch, ReactNode, useContext } from 'react';

type ConnectionDispatchProviderProps = {
  dispatch: Dispatch<ConnectionAction>;
  children?: ReactNode;
};

const ConnectionDispatchContext =
  createContext<Dispatch<ConnectionAction> | null>(null);

export const ConnectionDispatchProvider = ({
  dispatch,
  children,
}: ConnectionDispatchProviderProps) => {
  return (
    <ConnectionDispatchContext.Provider value={dispatch}>
      {children}
    </ConnectionDispatchContext.Provider>
  );
};

export const useConnectionDispatch = (): Dispatch<ConnectionAction> => {
  const connectionDispatch = useContext(ConnectionDispatchContext);
  if (connectionDispatch == null) {
    throw Error('ConnectionDispatch is not in the context');
  }
  return connectionDispatch;
};
